import { t } from "i18next";

import ModalWrapper from "@/src/components/molecules/ModalWrapper";

interface DeleteSavedSearchConfirmationModalProps {
  open: boolean;
  filterName: string;
  onClose: () => void;
  onConfirm: (filterName: string) => void;
}

const DeleteSavedSearchConfirmationModal = ({
  open,
  filterName,
  onClose,
  onConfirm
}: DeleteSavedSearchConfirmationModalProps) => (
  <ModalWrapper
    id="deleteSavedSearchConfirmationModal"
    open={open}
    onClose={onClose}
    title={t("dealer.searchFilterModal.title")}
    secondaryAction={{
      id: "cancelDeleteSavedSearchButton",
      label: t("general.cancel"),
      onClick: onClose
    }}
    primaryAction={{
      id: "confirmDeleteSavedSearchButton",
      label: t("general.delete"),
      onClick: () => onConfirm(filterName)
    }}
  >
    {t("dealer.searchFilterModal.body", { filterToBeDeleted: filterName })}
  </ModalWrapper>
);

export default DeleteSavedSearchConfirmationModal;
